import * as React from "react";
import 'shared/styles/bootstrap.scss';
import './TemplateListStyles.css';
import {WPTable} from "shared/controls/WPTable/WPTable";
import {WPTableSortDirectionEnum, WPTH} from "shared/controls/WPTable/WPTH";
import {WPBasicColumn} from "shared/controls/WPTable/Columns/WPBasicColumn";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {DeleteDialog} from "shared/controls/Dialogs/premade/DeleteDialog";
import {WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {faFileImport} from "@fortawesome/free-solid-svg-icons/faFileImport";
import {SpinnerButton} from "shared/controls/SpinnerButton";

library.add(faPlus);
library.add(faFileImport);
declare let ajaxurl;
export class CustomFieldApp extends React.Component<TemplateListProps, TemplateListState> {
    static defaultProps: Partial<TemplateListProps> = {};
    public file:HTMLInputElement;

    constructor(props: TemplateListProps) {
        super(props);
        this.state = {
            SortColumn:'',
            SortDirection:WPTableSortDirectionEnum.none,
            ImportIsBusy:false
        };
    }

    public render() {

        return (
            <div style={{padding:10}} className={'rednao'}>
                <h1>Custom Fields</h1>
                <input onChange={e=>this.FileSelected()} type={'file'} accept={'.zip'} ref={e=>this.file=e} style={{display:'none'}}/>
                <button onClick={e=>this.ActionSelected('Edit',null)}  className={'rnbtn rnbtn-success'}><FontAwesomeIcon icon={"plus"}/>Add New</button>
                <WPTable EmptyContent={
                    <div style={{padding:10,textAlign:'center'}}>

                        You haven't created any custom field yet!, <a onClick={e=>{e.preventDefault();this.ActionSelected('Edit',null)}} href={'#'}>Click here to create your first custom field</a>
                    </div>

                } Data={rednaoVarTemplateList.Templates} RowClicked={e=>this.ActionSelected('edit',e)} ActionClicked={(a,b)=>this.ActionSelected(a,b)}>
                    <WPBasicColumn PropertyName={'TemplateName'} Title={'Template Name'} IsSortable={true} IsClickable={true} IsPrimary={true}
                    Actions={[
                        {Title:'Edit',Id:'edit',ClassName:'edit'},
                        {Title:'Delete',Id:'delete',ClassName:'delete'}

                    ]}/>
                    <WPBasicColumn PropertyName={'FormName'} Title={'Form Name'} IsSortable={true}/>
                </WPTable>
            </div>


        )
    }

    public ActionSelected(action:string, form:any)
    {
        if(action=='delete')
        {
            DeleteDialog.Show(form.TemplateName,"Are you sure?", ()=>{
                return new Promise<boolean>( async resolve => {
                    let result=await WpAjaxPost.Post('Delete',{Id:form.Id});
                    if(result!=null)
                    {
                        let template=rednaoVarTemplateList.Templates.find(x=>x.Id==form.Id);
                        if(template!=null) {
                            rednaoVarTemplateList.Templates.splice(rednaoVarTemplateList.Templates.indexOf(template), 1);
                            this.forceUpdate();
                        }
                    }
                    resolve(result!=null);

                })

            });

            return;
        }



        let id=0;
        if(form!=null)
            id=form.Id;
        window.location.href=rednaoVarTemplateList.AdminUrl+'&template_id='+id;
    }

    private async FileSelected() {
        if(this.file.files.length==0)
            return;

        this.setState({ImportIsBusy:true});
        let result=await WpAjaxPost.Post('import',{},null,{ImportFile:this.file.files[0]});

        this.file.value='';

        if(result!=null)
            this.ActionSelected('edit',{Id:result.TemplateId});
        else
            this.setState({ImportIsBusy:false});

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TemplateListProps {

}

interface TemplateListState {
    SortColumn:string;
    SortDirection:WPTableSortDirectionEnum;
    ImportIsBusy:boolean;

}

//#endregion "My Region"